import { Bath, Building2, Hammer, PencilRuler, Trees, Wrench, type LucideIcon } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { services } from "@/lib/site-data";

const icons: Record<string, LucideIcon> = {
  Building2,
  PencilRuler,
  Bath,
  Wrench,
  Hammer,
  Trees,
};

export function Services() {
  return (
    <section id="sluzby" className="bg-background py-20 md:py-28">
      <div className="container-artbaz">
        <Reveal className="content-artbaz max-w-3xl">
          <span className="eyebrow">Služby</span>
          <h2 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Komplexné služby pod jednou strechou
          </h2>
          <p className="mt-6 text-base leading-relaxed text-muted-foreground sm:text-lg">
            Od prvotného návrhu až po finálne dokončenie projektu. Zabezpečujeme kompletné stavebné
            riešenia pre domácnosti, firmy aj investičné nehnuteľnosti.
          </p>
        </Reveal>

        <div className="content-artbaz mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
            const Icon = icons[service.icon];
            return (
              <Reveal key={service.title} delay={(i % 3) * 90}>
                <article className="group h-full rounded-2xl border border-border bg-card p-8 shadow-[var(--shadow-card)] transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1.5 hover:border-primary/60 hover:shadow-[var(--shadow-elevated)]">
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-accent text-primary-dark transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                    <Icon className="size-7" strokeWidth={1.75} />
                  </div>
                  <h3 className="mt-6 text-xl font-bold tracking-tight text-foreground">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {service.description}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
